<template>
  <div>
  
    <div class="switch1">
      <div class="table">
        <el-table
          height="400"
          ref="multipleTable"
          tooltip-effect="dark"
          style="width: 100%"
          :data="tableData"
        >
          <el-table-column prop="address" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="address" label="表达式类型"> </el-table-column>
          <el-table-column prop="address" label="分数"> </el-table-column>
          <el-table-column prop="address" label="信头key"> </el-table-column
          ><el-table-column prop="address" label="正则表达式过滤规则">
          </el-table-column
          ><el-table-column prop="address" label="策略类型"> </el-table-column>
          <el-table-column prop="address" label="操作">
            <template>
              <el-button type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pop-up" v-show="tanchu">
        <div class="find">
          <div class="find1">
            <div class="find-text">
              <span style="margin-right:4px"></span> 类型:
            </div>
            <div class="block">
              <el-select v-model="value" class="selece1">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="find1">
            <div class="find-text" style="padding-right:12px">
              <span style="margin:0 42px"></span> 分数:
            </div>
            <div class="block block1">
              <el-input
                v-model="input"
                placeholder="累计分数达到50，邮件拒收"
              ></el-input>
            </div>
          </div>
          <div class="find1">
            <div class="find-text" style="padding-right:12px">
              正则表达式过滤规则:
            </div>
            <div class="block block1">
              <el-input v-model="input"></el-input>
            </div>
          </div>
          <div class="find1">
            <div class="find-text">
              <span style="margin-right:-20px"></span> 策略类型:
            </div>
            <div class="block">
              <el-select v-model="value" class="selece1">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <el-row>
          <el-button type="primary" @click="tanSend()">保存</el-button>
          <el-button type="primary" @click="tanOff()">取消</el-button>
        </el-row>
      </div>
      <div class="gray" v-show="tanchu"></div>
    </div>
   
  </div>
</template>
<script>
export default {
  data() {
    return {
      input: "",
      time: new Date(2020, 9, 10, 18, 40),
      value1: "",

      tableData: [
        {
          address: "44",
        },
      ],
      emali: "",
      value: "",
      checkList: [],
      tanchu: false,
      options: [
        {
          value: "选项1",
          label: "不使用TLS",
        },
        {
          value: "选项2",
          label: "增加信头标记",
        },
        {
          value: "选项3",
          label: "强制TLS",
        },
      ],
      checked: "",
      fileList: [],
      show: false,
    };
  },
};
</script>
<style lang="less" scoped></style>
